import { Icon } from '@buggy/shared'
import { Button, ButtonProps, Modal } from 'antd'
import { FunctionComponent } from 'react'
import styled from 'styled-components'
import { useIntl } from '@/i18n/hooks/use-intl'

interface DeleteButtonProps extends Omit<ButtonProps, 'icon' | 'onClick'> {
  confirmModalTitle: string
  confirmModalContent?: string
  beforeDelete?: () => Promise<void> | void
  onDelete: () => Promise<void> | void
  iconSize?: number
  iconColor?: string
}

const DeleteButton: FunctionComponent<DeleteButtonProps> = ({
  beforeDelete,
  onDelete,
  confirmModalTitle,
  confirmModalContent,
  iconSize = 14,
  iconColor,
  ...otherProps
}) => {
  const { formatMessage } = useIntl()

  const handleClick = async (
    event: React.MouseEvent<HTMLElement, MouseEvent>,
  ): Promise<void> => {
    event.stopPropagation()

    await beforeDelete?.()
    Modal.confirm({
      centered: true,
      title: confirmModalTitle,
      content: confirmModalContent,
      cancelText: formatMessage({ id: 'general:btn_text_cancel' }),
      okText: formatMessage({ id: 'general:delete_btn' }),
      onOk: onDelete,
    })
  }

  return (
    <StyledButton
      {...otherProps}
      icon={<Icon color={iconColor} fontSize={iconSize} name='trash-2' />}
      onClick={handleClick}
    />
  )
}

const StyledButton = styled(Button)``

export default DeleteButton
